import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';
/**
 * Students connected right now (active session + authenticated activity in
 * the last minutes). Polls while the "En línea" tab is visible — same
 * polling approach as notifications.
 */
export function useOnlineStudents(oppositionId, enabled = true) {
    return useQuery({
        queryKey: ['students', 'online', oppositionId ?? ''],
        queryFn: () => apiClient(`/students/online${oppositionId ? `?opposition_id=${oppositionId}` : ''}`),
        enabled,
        refetchInterval: 30_000,
    });
}
//# sourceMappingURL=useOnlineStudents.js.map